export default __webpack_public_path__ + "static/media/PrettyImage.858326d6.png";